import moment from "moment";
import * as echarts from "echarts";
const getOption = (data1: Array<number>, type: string): any => {
  const x: string[] = [];
  const y: number[] = [];
  const days: string[] = [];
  let stationName: string = "";
  data1.forEach((e: any) => {
    x.push(
      moment(e.datetime, "YYYYMMDDHHmmss")
        .add(8, "hour")
        .format("DD日HH") + "时"
    );
    y.push(Math.round(e.rhu * 10) / 10);
    stationName = e.stationName;
  });

  const fontSize = 14;

  let leftPostion = 15;
  let topPostion = 30;
  let yAxisShow = false;
  let splitLine = false;
  let showAllSymbol = false;
  let titleShow = false;
  let xInterval = 5;
  let dataZoomDisAble = false;
  let dataZoom = 100;
  let xLabelFormat = undefined;
  let bottomPostion = 35;
  let tooltipShow = false;
  if (type === "full") {
    leftPostion = 35;
    topPostion = 40;
    titleShow = true;
    xInterval = 1;
    yAxisShow = true;
    splitLine = true;
    showAllSymbol = true;
    dataZoomDisAble = true;
    dataZoom = 100;
    xLabelFormat = function(value: string) {
      let pattern = new RegExp("[\u4E00-\u9FA5]+");
      const values = value.split("");
      let result = "";
      values.forEach((charValue) => {
        result += charValue;
        if (pattern.test(charValue)) {
          result += "\n";
        }
      });
      return result;
    };
    bottomPostion = 80;
    tooltipShow = true;
  }

  return {
    animation: false,
    title: {
      show: titleShow,
      textStyle: {
        color: "#2D96F7",
      },
      text: stationName + "-过去24小时湿度(%)",
    },
    tooltip: {
      trigger: "axis",
      show: tooltipShow,
    },
    grid: {
      left: leftPostion,
      right: 10,
      top: topPostion,
      bottom: bottomPostion,
    },
    xAxis: {
      type: "category",
      data: x,
      axisLabel: {
        fontFamily: "PingFangSC-Regular",
        interval: xInterval,
        formatter: xLabelFormat,
      },
      axisLine: {
        lineStyle: {
          show: false,
          color: "#2D96F7",
        },
      },
      axisTick: {
        show: false,
      },
    },

    yAxis: {
      show: yAxisShow,
      type: "value",
      min: (value: any) => Math.round(value.min - 1),
      max: (value: any) => Math.round(value.max + 1),
      // splitNumber: 1,
      splitLine: { show: splitLine },
      interval: 5,
      axisLine: {
        show: true,
        lineStyle: {
          color: "#2D96F7",
        },
      },
    },
    dataZoom: [
      {
        type: "inside",
        disabled: !dataZoomDisAble,
        start: 0,
        end: dataZoom,
      },
    ],
    series: {
      data: y,
      markPoint: {
        symbol: "pin",
        data: [
          {
            type: "max",
            name: "Max",
            itemStyle: {
              color: "rgba(250, 173, 20, 1)",
            },
          },
          {
            type: "min",
            name: "Min",
            itemStyle: {
              color: "RGBA(53, 154, 248, 0.7)",
            },
          },
        ],
      },
      showAllSymbol: showAllSymbol,
      symbol: "circle",
      smooth: true,
      label: {
        show: true,
        color: "#2D96F7",
        fontSize,
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(17, 134, 242, 0.5)",
          },
          {
            offset: 1,
            color: "rgba(17, 134, 242,0)",
          },
        ]),
      },
      lineStyle: {
        width: 2,
        color: "RGBA(83, 169, 250, 1)",
      },
      itemStyle: {
        color: "#0C99FF",
      },
      type: "line",
      yAxisIndex: 0,
    },
  };
};
export default getOption;
